import { http, createConfig } from 'wagmi'
import { mainnet, polygon } from 'wagmi/chains'
import { injected, metaMask } from 'wagmi/connectors'

export const config = createConfig({
  chains: [mainnet, polygon],
  connectors: [
    injected(),
    metaMask()
    // Removed walletConnect temporarily due to configuration issues
  ],
  transports: {
    [mainnet.id]: http('https://mainnet.gateway.tenderly.co/7LSqXLbWQ8ykzNCqWL6kUR'),
    [polygon.id]: http('https://polygon.gateway.tenderly.co/6FaTAredZghGFTbrlpg0q7')
  }
})